import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSelector } from '@reduxjs/toolkit';
import { emptyObj, isNullOrUndefined } from '@beef/utils';
import { USER_TYPE } from "../../../../constants";
import { selectInitData } from "../../../../store/selectors";
import { getUpperName, isElkPlanBMainBannerHideURLEnabled } from "../utils";
import { SpecialTariffType } from "../constants/enums";
import { convertAccumulators } from "../utils/accumulators";
export var selectIsMobileUser = function selectIsMobileUser(state) {
  var _selectInitData;
  return ((_selectInitData = selectInitData(state)) === null || _selectInitData === void 0 ? void 0 : _selectInitData.userType.toLowerCase()) === USER_TYPE.MOBILE;
};
export var selectIsConvergent = function selectIsConvergent(state) {
  var _selectInitData2;
  return ((_selectInitData2 = selectInitData(state)) === null || _selectInitData2 === void 0 ? void 0 : _selectInitData2.userType.toLowerCase()) === USER_TYPE.CONVERGENT;
};
export var selectIsFTTBUser = function selectIsFTTBUser(state) {
  var _selectInitData3;
  return ((_selectInitData3 = selectInitData(state)) === null || _selectInitData3 === void 0 ? void 0 : _selectInitData3.userType.toLowerCase()) === USER_TYPE.FTTB;
};
export var selectIsB2B = function selectIsB2B(state) {
  var _selectInitData4;
  return (_selectInitData4 = selectInitData(state)) === null || _selectInitData4 === void 0 ? void 0 : _selectInitData4.isB2B;
};
export var selectAccountType = function selectAccountType(state) {
  return selectIsB2B(state) ? 'business' : 'mobile';
};
export var selectIsSvyazZ = function selectIsSvyazZ(state) {
  var _selectTariffBlock;
  return ((_selectTariffBlock = selectTariffBlock(state)) === null || _selectTariffBlock === void 0 ? void 0 : _selectTariffBlock.specialTariffType) === SpecialTariffType.SvyazZ;
};
export var selectIsProstoy = function selectIsProstoy(state) {
  var _selectTariff;
  return ((_selectTariff = selectTariff(state)) === null || _selectTariff === void 0 ? void 0 : _selectTariff.specialTariffType) === SpecialTariffType.Prostoy;
};
export var selectMobile = function selectMobile(state) {
  var _state$connectionBloc;
  return state === null || state === void 0 || (_state$connectionBloc = state.connectionBlock) === null || _state$connectionBloc === void 0 ? void 0 : _state$connectionBloc.mobile;
};
export var selectMobileConnectionBlockData = function selectMobileConnectionBlockData(state) {
  var _selectMobile;
  return (_selectMobile = selectMobile(state)) === null || _selectMobile === void 0 ? void 0 : _selectMobile.data;
};
export var selectFUB = function selectFUB(state) {
  return state.fub;
};
export var selectMainBalance = function selectMainBalance(state) {
  return selectFUB(state).mainBalance;
};
export var selectMainBalanceLoading = function selectMainBalanceLoading(state) {
  return selectFUB(state).mainBalanceLoading;
};
export var selectHasMainBalanceError = function selectHasMainBalanceError(state) {
  return selectFUB(state).hasMainBalanceError;
};
export var selectMainBalanceName = function selectMainBalanceName(state) {
  var _selectMainBalance;
  return (((_selectMainBalance = selectMainBalance(state)) === null || _selectMainBalance === void 0 ? void 0 : _selectMainBalance.balanceName) || '').toLowerCase();
};
export var selectShowUnbilledCharges = createSelector([selectMainBalance], function (mainBalance) {
  return (mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.paymentType) === 'Postpaid' && Number.isFinite(mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.unbilledCharges) && !Number.isNaN(parseFloat(mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.unbilledCharges));
});
export var selectFubGroupsInfo = function selectFubGroupsInfo(state) {
  var _selectFUB;
  return (_selectFUB = selectFUB(state)) === null || _selectFUB === void 0 ? void 0 : _selectFUB.fubGroupsInfo;
};
export var selectFubGroupsError = function selectFubGroupsError(state) {
  var _selectFubGroupsInfo;
  return (_selectFubGroupsInfo = selectFubGroupsInfo(state)) === null || _selectFubGroupsInfo === void 0 ? void 0 : _selectFubGroupsInfo.isError;
};
export var selectFubMembers = function selectFubMembers(state) {
  var _selectFubGroupsInfo2;
  return (_selectFubGroupsInfo2 = selectFubGroupsInfo(state)) === null || _selectFubGroupsInfo2 === void 0 || (_selectFubGroupsInfo2 = _selectFubGroupsInfo2.data) === null || _selectFubGroupsInfo2 === void 0 ? void 0 : _selectFubGroupsInfo2.members;
};
export var selectFubGroupsCount = function selectFubGroupsCount(state) {
  var _selectFubGroupsInfo3;
  return (_selectFubGroupsInfo3 = selectFubGroupsInfo(state)) === null || _selectFubGroupsInfo3 === void 0 || (_selectFubGroupsInfo3 = _selectFubGroupsInfo3.data) === null || _selectFubGroupsInfo3 === void 0 ? void 0 : _selectFubGroupsInfo3.groupCount;
};
export var selectFubMembersCount = function selectFubMembersCount(state) {
  var _selectFubGroupsInfo4;
  return (_selectFubGroupsInfo4 = selectFubGroupsInfo(state)) === null || _selectFubGroupsInfo4 === void 0 || (_selectFubGroupsInfo4 = _selectFubGroupsInfo4.data) === null || _selectFubGroupsInfo4 === void 0 ? void 0 : _selectFubGroupsInfo4.memberCount;
};
export var selectFubStatus = function selectFubStatus(state) {
  var _selectFubGroupsInfo5;
  return (_selectFubGroupsInfo5 = selectFubGroupsInfo(state)) === null || _selectFubGroupsInfo5 === void 0 || (_selectFubGroupsInfo5 = _selectFubGroupsInfo5.data) === null || _selectFubGroupsInfo5 === void 0 || (_selectFubGroupsInfo5 = _selectFubGroupsInfo5.currentStatus) === null || _selectFubGroupsInfo5 === void 0 ? void 0 : _selectFubGroupsInfo5.toLowerCase();
};
export var selectFubGroupsLoading = function selectFubGroupsLoading(state) {
  var _selectFubGroupsInfo6;
  return (_selectFubGroupsInfo6 = selectFubGroupsInfo(state)) === null || _selectFubGroupsInfo6 === void 0 ? void 0 : _selectFubGroupsInfo6.fubGroupsLoading;
};
export var selectTariff = function selectTariff(state) {
  var _selectMobileConnecti;
  return (_selectMobileConnecti = selectMobileConnectionBlockData(state)) === null || _selectMobileConnecti === void 0 ? void 0 : _selectMobileConnecti.tariff;
};
export var selectIsPlanB = createSelector([selectTariff], function (tariff) {
  return (tariff === null || tariff === void 0 ? void 0 : tariff.specialTariffType) === SpecialTariffType.PlanB;
});
export var selectMobileTariffPowerPending = function selectMobileTariffPowerPending(state) {
  return selectMobile(state).powerPending;
};
export var selectIsClickableTariff = function selectIsClickableTariff(state) {
  return !(selectIsPlanB(state) && isElkPlanBMainBannerHideURLEnabled());
};
export var selectMobileConnectionBlockError = function selectMobileConnectionBlockError(state) {
  return selectMobile(state).error;
};
export var selectMobileConnectionTexts = function selectMobileConnectionTexts(state) {
  return selectMobile(state).texts;
};
var selectMobileConnectionAccumulatorsData = function selectMobileConnectionAccumulatorsData(state) {
  var _selectMobileConnecti2;
  return (_selectMobileConnecti2 = selectMobileConnectionBlockData(state)) === null || _selectMobileConnecti2 === void 0 ? void 0 : _selectMobileConnecti2.accumulators;
};
var selectMobileConnectionAccumulatorsItems = function selectMobileConnectionAccumulatorsItems(state) {
  var _selectMobileConnecti3;
  return (_selectMobileConnecti3 = selectMobileConnectionAccumulatorsData(state)) === null || _selectMobileConnecti3 === void 0 ? void 0 : _selectMobileConnecti3.items;
};
export var selectMobileConnectionAccumulators = function selectMobileConnectionAccumulators(state) {
  return convertAccumulators(selectMobileConnectionAccumulatorsItems(state));
};
var selectAccumulatorsLength = function selectAccumulatorsLength(state) {
  var _selectMobileConnecti4;
  return (_selectMobileConnecti4 = selectMobileConnectionAccumulators(state)) === null || _selectMobileConnecti4 === void 0 ? void 0 : _selectMobileConnecti4.length;
};
var selectMobileConnectionBlockPower = function selectMobileConnectionBlockPower(state) {
  var _selectMobile2;
  return (_selectMobile2 = selectMobile(state)) === null || _selectMobile2 === void 0 ? void 0 : _selectMobile2.power.data;
};
var selectPowerAnimalSoc = function selectPowerAnimalSoc(state) {
  var _selectMobileConnecti5;
  return (_selectMobileConnecti5 = selectMobileConnectionBlockPower(state)) === null || _selectMobileConnecti5 === void 0 ? void 0 : _selectMobileConnecti5.animalSoc;
};
export var selectTariffBlock = function selectTariffBlock(state) {
  var _selectMobileConnecti6;
  return (_selectMobileConnecti6 = selectMobileConnectionBlockData(state)) === null || _selectMobileConnecti6 === void 0 ? void 0 : _selectMobileConnecti6.tariff;
};
export var selectTariffName = function selectTariffName(state) {
  var _selectTariffBlock2;
  return (_selectTariffBlock2 = selectTariffBlock(state)) === null || _selectTariffBlock2 === void 0 ? void 0 : _selectTariffBlock2.name;
};
export var selectTariffLink = function selectTariffLink(state) {
  var _selectTariffBlock3;
  return ((_selectTariffBlock3 = selectTariffBlock(state)) === null || _selectTariffBlock3 === void 0 ? void 0 : _selectTariffBlock3.url) || '/customers/products/mobile/profile/';
};
export var selectIsArchiveTariff = function selectIsArchiveTariff(state) {
  var _selectTariffBlock4;
  return (_selectTariffBlock4 = selectTariffBlock(state)) === null || _selectTariffBlock4 === void 0 ? void 0 : _selectTariffBlock4.isArchive;
};
export var selectMobileConnectionTariff = createSelector([selectTariff, selectMobileConnectionTexts, selectAccumulatorsLength, selectPowerAnimalSoc, selectMobileTariffPowerPending], function (tariff, texts, length, animalSoc, pending) {
  if (isNullOrUndefined(tariff)) return emptyObj;
  var animalName = getUpperName(animalSoc);
  var title = animalName ? "\u0422\u0430\u0440\u0438\u0444 UP - ".concat(animalName) : (tariff === null || tariff === void 0 ? void 0 : tariff.customTitle) || (tariff === null || tariff === void 0 ? void 0 : tariff.name) || '';
  return _objectSpread(_objectSpread({}, tariff), {}, {
    url: selectTariffLink(tariff === null || tariff === void 0 ? void 0 : tariff.url),
    title: pending ? '' : title,
    animalSoc: animalSoc || '',
    image: (tariff === null || tariff === void 0 ? void 0 : tariff.image) || (texts === null || texts === void 0 ? void 0 : texts.desktopDefaultImage),
    accumulatorsNum: length,
    source: [{
      srcset: (tariff === null || tariff === void 0 ? void 0 : tariff.image) || (texts === null || texts === void 0 ? void 0 : texts.desktopDefaultImage),
      media: '(min-width: 768px)'
    }, {
      srcset: (tariff === null || tariff === void 0 ? void 0 : tariff.imageMobile) || (texts === null || texts === void 0 ? void 0 : texts.mobileDefaultImage),
      media: '(max-width: 768px)'
    }]
  });
});
var selectConvergent = function selectConvergent(state) {
  var _state$connectionBloc2;
  return state === null || state === void 0 || (_state$connectionBloc2 = state.connectionBlock) === null || _state$connectionBloc2 === void 0 ? void 0 : _state$connectionBloc2.convergent;
};
export var selectMobileConnectionBlockPrice = function selectMobileConnectionBlockPrice(state) {
  var _selectMobile3;
  return (_selectMobile3 = selectMobile(state)) === null || _selectMobile3 === void 0 ? void 0 : _selectMobile3.price;
};
export var selectMobileConnectionPrice = function selectMobileConnectionPrice(state) {
  var _price$data;
  var price = selectMobileConnectionBlockPrice(state);
  return _objectSpread(_objectSpread({}, price), {}, {
    data: _objectSpread(_objectSpread({}, price === null || price === void 0 ? void 0 : price.data), {}, {
      rcRate: price === null || price === void 0 || (_price$data = price.data) === null || _price$data === void 0 ? void 0 : _price$data.rcRate
    })
  });
};
export var selectConvergentData = function selectConvergentData(state) {
  var _selectConvergent;
  return (_selectConvergent = selectConvergent(state)) === null || _selectConvergent === void 0 ? void 0 : _selectConvergent.data;
};
export var selectConvergentDataPending = function selectConvergentDataPending(state) {
  var _selectConvergent2;
  return (_selectConvergent2 = selectConvergent(state)) === null || _selectConvergent2 === void 0 ? void 0 : _selectConvergent2.pending;
};
export var selectConvergentDataError = function selectConvergentDataError(state) {
  var _selectConvergent3;
  return (_selectConvergent3 = selectConvergent(state)) === null || _selectConvergent3 === void 0 ? void 0 : _selectConvergent3.error;
};
export var selectRedesignMobileConnectionPrice = selectMobileConnectionPrice;
export var selectMobileAndConvergentTariffPrice = function selectMobileAndConvergentTariffPrice(state) {
  var _selectRedesignMobile;
  return (_selectRedesignMobile = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile === void 0 || (_selectRedesignMobile = _selectRedesignMobile.data) === null || _selectRedesignMobile === void 0 ? void 0 : _selectRedesignMobile.rcRate;
};
var selectFTTB = function selectFTTB(state) {
  var _state$connectionBloc3;
  return state === null || state === void 0 || (_state$connectionBloc3 = state.connectionBlock) === null || _state$connectionBloc3 === void 0 ? void 0 : _state$connectionBloc3.fttb;
};
export var selectFTTBConnectionBlockData = function selectFTTBConnectionBlockData(state) {
  var _selectFTTB;
  return (_selectFTTB = selectFTTB(state)) === null || _selectFTTB === void 0 ? void 0 : _selectFTTB.data;
};
export var selectFTTBConnectionBlockPending = function selectFTTBConnectionBlockPending(state) {
  var _selectFTTB2;
  return (_selectFTTB2 = selectFTTB(state)) === null || _selectFTTB2 === void 0 ? void 0 : _selectFTTB2.pending;
};
export var selectIsBalanceListOpen = function selectIsBalanceListOpen(state) {
  return selectFUB(state).openedModal === 'BalanceListModal' || selectFUB(state).openedModal === 'BalanceListModalAfterBonusBalanceModal';
};
export var selectNeedSendPostMessage = function selectNeedSendPostMessage(state) {
  return selectFUB(state).requiresPostMessage;
};